import { setActiveCompareIcons, addHandlerClickOnCompareIcon } from './compare';

const yandexGoal = (goal) => {
  // eslint-disable-next-line
  ym(86243033, 'reachGoal', goal);
};

window.sendYandexGoal = yandexGoal;

const ecommerceAction = (action, data) => {
  if (!data) {
    return;
  }
  if (window.ym) {
    // eslint-disable-next-line
    dataLayer.push({
      ecommerce: {
        currencyCode: 'RUB',
        [action]: {
          products: [
            {
              id: data.dataset.ecommerceId,
              name: data.dataset.ecommerceName,
              price: data.dataset.ecommercePrice,
              quantity: data.dataset.ecommerceQuantity,
            },
          ],
        },
      },
    });
  } else {
    setTimeout(() => {
      ecommerceAction(action, data);
    }, 1000);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('[data-goal]');
  elements.forEach((el) => {
    el.addEventListener('click', () => {
      const goal = el.attributes['data-goal'].value;
      yandexGoal(goal);
      ecommerceAction('add', el);
    });
  });

  const deleteButtons = document.querySelectorAll('.cart-card__delete');
  deleteButtons.forEach((el) => {
    if (el.classList.contains('init')) {
      return;
    }
    el.addEventListener('click', () => {
      ecommerceAction('remove', el);
    });

    el.classList.add('init');
  });
});

window.showError = async (title = '', text = 'К сожалению, время сессии истекло.<br> Страница будет перезагружена', hideLoader = true) => {
  const isLoad = await window.isLoadPopup('universal-popup');
  if (!isLoad) {
    return;
  }
  const popup = document.querySelector('#universal-popup');
  const popupTitle = popup.querySelector('.universal-message__title');
  const popupText = popup.querySelector('.universal-message__text');

  popupTitle.innerHTML = title;
  popupText.innerHTML = text;

  if (hideLoader) {
    window.loaderHide('body');
  }

  popup.classList.add('open');
  setTimeout(() => {
    window.location.reload();
  }, 2500);
};

const lazyUpdate = () => {
  document.querySelectorAll('[data-src]').forEach((el) => {
    el.src = el.dataset.src;
  });
  document.querySelectorAll('[data-srcset]').forEach((el) => {
    el.srcset = el.dataset.srcset;
  });
};

document.addEventListener('DOMContentLoaded', () => {
  lazyUpdate();
});

window.addEventListener('popstate', () => {
  setTimeout(() => {
    lazyUpdate();
  }, 0);
});

window.addEventListener('popstate', () => {
  setTimeout(() => {
    setActiveCompareIcons();
    addHandlerClickOnCompareIcon();
    window.addHandlerClickOnFavoriteIcon();
    window.setActiveFavoriteIcons();
    window.setBasketButtons();
    window.initTabs();
  }, 0);
});

window.addEventListener('onAjaxSuccess', () => {
  setTimeout(() => {
    setActiveCompareIcons();
    addHandlerClickOnCompareIcon();
    window.addHandlerClickOnFavoriteIcon();
    window.setActiveFavoriteIcons();
    window.setBasketButtons();
    window.initTabs();
  }, 0);
});

window.lazyUpdate = lazyUpdate;
